import FilterButtonGroup from "components/FilterButtonGroup";
import { useField } from "lib/form";
import { device, mq } from "lib/media-query";
import React from "react";
import { useCount } from "services/search";
import styled from "styled-components";

const Grid = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;

    ${mq.to(device.TABLET)`
     grid-template-columns: 1fr;
  `};
    ${({ condensed }) => (condensed ? "grid-template-columns: 1fr" : "")}
`;

const filterOptions = {
    "Geen voorkeur": "",
    "Toon alleen import": "true",
    "Verberg import": "false"
};

export const ImportAutoFilter = ({ condensed }) => {
    const count = useCount("geimporteerd");
    const totalCount = useCount("total");
    const [importAutoValue, , onImportAutoChange] = useField("geimporteerd");

    const getCountValue = (optionValue) => {
        return optionValue === ""
            ? importAutoValue.length === 0
                ? totalCount
                : undefined
            : count && count[optionValue];
    };

    const importAutoOptions =
        Object.entries(filterOptions).map(([key, value]) => ({
            id: value,
            displayName: `${key}`,
            naam: `${key}`,
            aantal: getCountValue(value)
        })) || [];

    return (
        <Grid condensed={condensed}>
            <FilterButtonGroup
                filterId="filter-geimporteerd"
                dataTestId="filter-geimporteerd"
                options={importAutoOptions}
                value={importAutoValue || [""]}
                handleChange={(_, value) => {
                    onImportAutoChange(value && value[0] !== "" ? value : []);
                }}
                datalayerKey="geimporteerd"
                columns={3}
                isSingle
            />
        </Grid>
    );
};
